import "./RedeemLocationsPopup.scss"

import React, { useState, useCallback } from 'react';
import { Col, Modal, Row, Typography } from 'antd';
import { useSelector } from 'react-redux';
import { IApplicationState } from '../../store';
import { useTranslation } from 'react-i18next';
import RedeemVenueList from './RedeemVenueList';
import CurrencyPicker from '../currency-picker/currency-picker';
import ZLButton, { ButtonType } from "../zl-button/zl-button";
// import { actionCreators as SessionActions } from '../../store/Sessions'; // example

export interface IRedeemLocationsPopupProps { }

const RedeemLocationsPopup: React.FC<IRedeemLocationsPopupProps> = () => {
    const { t } = useTranslation();

    const listContainerId = "redeem-location-popup-list";

    const viewLocationsLabel = t('globalGiftVouchers.header.validLocationsBtn');
    const popupTitle = t('globalGiftVouchers.redeemPopup.title');
    const currencyLabel = t('globalGiftVouchers.currencyPicker.currencyLabel');

    const selectedCurrency = useSelector(
        (state: IApplicationState) => state.giftVoucher.selectedVoucherCurrency
    );

    const [open, setOpen] = useState(false);

    const onOpen = useCallback(() => setOpen(true), []);
    const onClose = useCallback(() => setOpen(false), []);

    const onConfirm = useCallback(() => {
        // Dispatch any Redux actions here if needed, e.g.:
        // dispatch(SessionActions.someAction(payload));
        setOpen(false);
    }, [/* dispatch */]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center' }} className="redeem-locations-host">

            {/*The UI button or link that opens the popup*/}
            <ZLButton type={ButtonType.Primary} onClick={onOpen}>
                {viewLocationsLabel}
            </ZLButton>

            {/*THE ACTUAL POPUP*/}
            <Modal
                open={open}
                onOk={onConfirm}
                onCancel={onClose}
                maskClosable
                destroyOnClose
                centered
                title={<div style={{
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    width: '100%',
                    fontSize: '20px'
                }}>{popupTitle}</div>}
                className="redeem-locations-popup"
                footer={null}

            >
                <Col>
                    <Row>
                        <Typography.Text style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {currencyLabel}:
                        </Typography.Text>
                    </Row>
                    <Row style={{paddingBottom:'15px'}} >
                        <CurrencyPicker />
                    </Row>
                    <Row id={listContainerId} >
                        {selectedCurrency && <RedeemVenueList parentContainerId={listContainerId} currencyFilter={selectedCurrency} />}
                    </Row>
                </Col>
            </Modal>
        </div>
    );
};

export default RedeemLocationsPopup;
